import React from 'react';
import { ActionCode } from '@/store/services/configLogsService';

export interface ActionProps {

  action?: {
    name?: string;
    code?: ActionCode | string;
  };
}

export const getActionColorClass = (code?: ActionCode | string): string => {
  if (!code) return 'text-blue-500';

  const normalizedCode = String(code).toUpperCase();
  switch (normalizedCode) {
    case ActionCode.CREATE:
      return 'text-light-success';
    case ActionCode.DELETE:
      return 'text-light-warning';
    case ActionCode.UPDATE:
      return 'text-light-information';
    default:
      return 'text-blue-500';
  }
};

export default function Action({

  action,
}: ActionProps) {
  const resolvedCode =  action?.code;
  const resolvedName = action?.name || resolvedCode;

  if (!resolvedCode && !resolvedName) {
    return <span>-</span>;
  }

  const colorClass = getActionColorClass(resolvedCode);

  return (
    <span className={`font-semibold ${colorClass}`.trim()}>
      {resolvedName}
    </span>
  );
}
